import React, { useState } from "react";
import Button from "../components/ui/Button";
import { useApi } from "../context/ApiContext";
import "./AddCollection.css";

export default function AddCollection({ onAdd }) {
    const { apiFetch } = useApi();
    const [name, setName] = useState("");
    const [error, setError] = useState("");

    const add = async (e) => {
        e.preventDefault();
        setError("");

        const trimmed = name.trim();
        if (!trimmed) return;

        const res = await apiFetch("/collections", {
            method: "POST",
            body: JSON.stringify({ name: trimmed }),
            headers: { "Content-Type": "application/json" }
        }).then(r => r.json());

        if (res.success) {
            setName("");
            onAdd();
        } else {
            setError(res.error || "Erreur API");
        }
    };

    return (
        <form id="ac-form" onSubmit={add}>
            <input
                id="ac-input"
                type="text"
                placeholder="Nouvelle collection…"
                value={name}
                onChange={e => setName(e.target.value)}
            />
            <Button variant="secondary" type="submit">Créer</Button>
            {error && <p className="notice notice--error">{error}</p>}
        </form>
    );
}
